<template>
    <div class="auth-screen">
        <div class="auth-card">
            <img class="auth-logo" src="/logo.png" alt="Fytlix" />
            <h1 class="auth-title">{{ $t('selectClient') }}</h1>

            <template v-if="clients.length === 0">
                <p class="auth-subtitle">{{ $t('noClients') }}</p>
                <button class="btn btn-block" @click="logout">
                    <i class="fa-solid fa-right-from-bracket"></i> {{ $t('logout') }}
                </button>
            </template>

            <template v-else>
                <p class="auth-subtitle">{{ $t('selectClientSubtitle') }}</p>
                <button v-for="client in clients" :key="client.client_id"
                        :class="{ 'client-item': true, active: client.client_id === $store.state.selectedClientId }"
                        @click="choose(client)">
                    <span class="client-avatar">{{ initial(displayName(client)) }}</span>
                    <span class="client-name">{{ displayName(client) }}</span>
                    <i v-if="client.client_id === $store.state.selectedClientId" class="fa-solid fa-check"></i>
                    <i v-else class="fa-solid fa-chevron-right chev"></i>
                </button>

                <div class="auth-footer">
                    <a href="#" @click.prevent="logout">{{ $t('logout') }}</a>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SelectClientView',
    computed: {
        clients() {
            return this.$store.state.clients;
        }
    },
    methods: {
        initial(name) {
            return (name || '?').trim().charAt(0).toUpperCase();
        },
        // The public sports-center name, falling back to the account name when a club hasn't set one.
        displayName(client) {
            return client.sport_center_name || client.name;
        },
        choose(client) {
            this.$store.commit('setSelectedClient', client.client_id);
            this.$store.commit('setPerson', null);
            this.$router.push({ name: 'home' });
        },
        async logout() {
            await this.$api.post('logout', {}, { client: false });
            this.$store.commit('reset');
            this.$router.push({ name: 'login' });
        }
    }
};
</script>
